import('@gfortaine/qr-code-generator/qrcodegen.js').then((rawModule) => eval.call(null, rawModule.default));
